import useIsNarrowerThan from '@/hooks/useIsNarrowerThan';

/**
 * Returns true is using the mobile bidding console
 */
const useShowMobileConsole = () => {
    const isMobileConsole = useIsNarrowerThan(999);

    return isMobileConsole;
};

export default useShowMobileConsole;
